import React, { useContext, useEffect, useRef } from 'react';
import { NMUI4DContext } from 'app/common/context/NMUI4DContext';
import { UnityMessageOutgoingEvent } from 'app/common/eventbus/Events';
import { LoadBaseMapTileRequest } from 'app/unity/ContentViewerTypes/LoadBaseMapTileRequest';
import { MapViewChangedNotification } from 'app/unity/ContentViewerTypes/MapViewChangedNotification';
import { MapTileCacheChangedNotification } from 'app/unity/ContentViewerTypes/MapTileCacheChangedNotification';
import { MapTile } from 'app/unity/ContentViewerTypes/MapTile';

export const MapTiling = () => {
    const context = useContext(NMUI4DContext);

    const unityCachedTiles = useRef<MapTile[]>([]);

    const handleMapViewChangedAsync = async (data: MapViewChangedNotification) => {
        const baseMapInfo = await context.mapTileFetcher.getApplicableBaseMapAsync(data);

        const tiles: { tileX: number; tileY: number }[] = [];
        baseMapInfo.visibleTiles.forEach(visibleTile => {
            for (let y = visibleTile.topLeftTileY; y < visibleTile.topLeftTileY + visibleTile.tileCountY; ++y) {
                for (let x = visibleTile.topLeftTileX; x < visibleTile.topLeftTileX + visibleTile.tileCountX; ++x) {
                    tiles.push({ tileX: x, tileY: y });
                }
            }
        });

        const tileData = await context.mapTileFetcher.getTilesAsync(
            baseMapInfo.tileMatrixIndex,
            tiles,
            unityCachedTiles.current,
        );

        const newRequest = new LoadBaseMapTileRequest({
            baseMapInfo: baseMapInfo,
            tiles: tileData,
        });
        context.eventBus.publish(
            new UnityMessageOutgoingEvent(JSON.stringify({ type: 'LoadBaseMapTileRequest', data: newRequest })),
        );
    };

    useEffect(() => {
        interface IMapViewChangedNotification {
            type: 'MapViewChangedNotification';
            data: MapViewChangedNotification;
        }
        interface IMapTileCacheChangedNotification {
            type: 'MapTileCacheChangedNotification';
            data: MapTileCacheChangedNotification;
        }

        context.unityNotificationListener.register<IMapViewChangedNotification>(
            'MapViewChangedNotification',
            notification =>
                void handleMapViewChangedAsync(notification.data).catch(reason =>
                    context.logger.error('Failed initial tiles request', reason),
                ),
        );
        context.unityNotificationListener.register<IMapTileCacheChangedNotification>(
            'MapTileCacheChangedNotification',
            notification => (unityCachedTiles.current = notification.data.cachedTiles),
        );
    }, []);

    return <></>;
};
